import * as i0 from '@angular/core';
import { Component, Optional, NgModule } from '@angular/core';
import * as i2 from '@spartacus/core';
import { CxDatePipe, UrlModule, I18nModule } from '@spartacus/core';
import { EMPTY } from 'rxjs';
import * as i1 from '@spartacus/cart/base/root';
import { CartOutlets } from '@spartacus/cart/base/root';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { IconModule, provideOutlet, OutletPosition } from '@spartacus/storefront';
import { PDFInvoicesComponentsModule } from '@spartacus/pdf-invoices/components';
import { RequestedDeliveryDateComponentsModule } from '@spartacus/requested-delivery-date/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = (a0, a1) => ({
  quantity: a0,
  date: a1
});
function ScheduleLinesComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 5);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const scheduleLine_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-describedby", ctx_r2.getScheduleLineInfoId(i_r2));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r2.getScheduleLineInfoId(i_r2));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 6, "s4omScheduleLines.a11y.scheduleLineEntryInfo", i0.ɵɵpureFunction2(14, _c0, scheduleLine_r1.confirmedQuantity, ctx_r2.getLongDate(scheduleLine_r1.confirmedAt))), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 9, scheduleLine_r1 == null ? null : scheduleLine_r1.confirmedAt, "M/d/yyyy"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 12, "s4omScheduleLines.quantity"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", scheduleLine_r1 == null ? null : scheduleLine_r1.confirmedQuantity, " ");
  }
}
function ScheduleLinesComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, ScheduleLinesComponent_ng_container_0_ng_container_1_div_2_Template, 12, 17, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", orderEntry_r4.scheduleLines);
  }
}
function ScheduleLinesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleLinesComponent_ng_container_0_ng_container_1_Template, 3, 1, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderEntry_r4 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasScheduleLines(orderEntry_r4));
  }
}
class ScheduleLinesComponent {
  constructor(cartItemContext, translationService, datePipe) {
    this.cartItemContext = cartItemContext;
    this.translationService = translationService;
    this.datePipe = datePipe;
    this.orderEntry$ = this.cartItemContext?.item$ ?? EMPTY;
  }
  /**
   * Verifies whether the Schedule Line infos have any entries.
   * Only in this case we want to display the schedule line summary
   *
   * @param {OrderEntry} item - Cart item
   * @returns {boolean} - whether the Schedule Line information is present for the order
   */
  hasScheduleLines(item) {
    const scheduleLines = item.scheduleLines;
    return scheduleLines != null && scheduleLines.length > 0;
  }
  getScheduleLineInfoId(index) {
    return 'cx-schedule-line-info-' + index.toString();
  }
  getLongDate(date) {
    if (!date) {
      return '';
    }
    return this.datePipe.transform(date);
  }
  static {
    this.ɵfac = function ScheduleLinesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScheduleLinesComponent)(i0.ɵɵdirectiveInject(i1.CartItemContext, 8), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i2.CxDatePipe));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ScheduleLinesComponent,
      selectors: [["cx-schedule-lines"]],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([CxDatePipe])],
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "cx-code"], ["class", "cx-schedule-line-info", 4, "ngFor", "ngForOf"], [1, "cx-schedule-line-info"], [1, "cx-visually-hidden", 3, "id"], ["aria-hidden", "true", 1, "cx-value"], ["aria-hidden", "true", 1, "cx-label"]],
      template: function ScheduleLinesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ScheduleLinesComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.orderEntry$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.AsyncPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScheduleLinesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-schedule-lines',
      providers: [CxDatePipe],
      standalone: false,
      template: "<ng-container *ngIf=\"orderEntry$ | async as orderEntry\">\n  <ng-container *ngIf=\"hasScheduleLines(orderEntry)\">\n    <div class=\"cx-code\">\n      <div\n        *ngFor=\"let scheduleLine of orderEntry.scheduleLines; let i = index\"\n        class=\"cx-schedule-line-info\"\n        attr.aria-describedby=\"{{ getScheduleLineInfoId(i) }}\"\n      >\n        <div id=\"{{ getScheduleLineInfoId(i) }}\" class=\"cx-visually-hidden\">\n          {{\n            's4omScheduleLines.a11y.scheduleLineEntryInfo'\n              | cxTranslate\n                : {\n                    quantity: scheduleLine.confirmedQuantity,\n                    date: getLongDate(scheduleLine.confirmedAt),\n                  }\n          }}\n        </div>\n        <div class=\"cx-value\" aria-hidden=\"true\">\n          {{ scheduleLine?.confirmedAt | cxDate: 'M/d/yyyy' }}\n        </div>\n        <div class=\"cx-label\" aria-hidden=\"true\">\n          {{ 's4omScheduleLines.quantity' | cxTranslate }}\n        </div>\n        <div class=\"cx-value\" aria-hidden=\"true\">\n          {{ scheduleLine?.confirmedQuantity }}\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.CartItemContext,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i2.TranslationService
  }, {
    type: i2.CxDatePipe
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScheduleLinesModule {
  static {
    this.ɵfac = function ScheduleLinesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScheduleLinesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ScheduleLinesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, UrlModule, I18nModule, IconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScheduleLinesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, UrlModule, I18nModule, IconModule],
      declarations: [ScheduleLinesComponent],
      exports: [ScheduleLinesComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const S4OM_FEATURE = 'S4HANA-Order-Management';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class S4omRootModule {
  static {
    this.ɵfac = function S4omRootModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || S4omRootModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: S4omRootModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideOutlet({
        id: CartOutlets.ITEM_DETAILS,
        position: OutletPosition.AFTER,
        component: ScheduleLinesComponent
      })],
      imports: [ScheduleLinesModule, RequestedDeliveryDateComponentsModule,
      //Adding dependency with Requested Delivery Date so that the library gets installed along with S4OM
      PDFInvoicesComponentsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(S4omRootModule, [{
    type: NgModule,
    args: [{
      imports: [ScheduleLinesModule, RequestedDeliveryDateComponentsModule,
      //Adding dependency with Requested Delivery Date so that the library gets installed along with S4OM
      PDFInvoicesComponentsModule //Adding dependency with PDF Invoices so that the library gets installed along with S4OM
      ],
      providers: [provideOutlet({
        id: CartOutlets.ITEM_DETAILS,
        position: OutletPosition.AFTER,
        component: ScheduleLinesComponent
      })]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { S4OM_FEATURE, S4omRootModule, ScheduleLinesComponent, ScheduleLinesModule };
